export const SPLASH_TEMPLATE = 'SplashScreenInterface.v1_0.SplashTemplate';
export const INFORMATION_BLOCK_ELEMENT = 'SplashScreenInterface.v1_0.InformationBlockElement';
